/**
 * Hex colour entry that forgives a missing "#" and 3-digit shorthand.
 *
 * Customers paste codes from brand guides both ways ("3AABE8", "#3AABE8",
 * "#fa0"). `<input type="color">` and CSS reject the bare form, so the preview
 * showed black or nothing even though the code was fine.
 */

/** "3aabe8" | "#3AABE8" | "#fa0" → "#3AABE8" / "#FFAA00"; null if not a hex colour. */
export function normalizeHex(input: string | undefined | null): string | null {
  const raw = (input ?? '').trim().replace(/^#+/, '');
  if (/^[0-9a-f]{3}$/i.test(raw)) {
    return `#${raw.split('').map((c) => c + c).join('').toUpperCase()}`;
  }
  if (/^[0-9a-f]{6}$/i.test(raw)) return `#${raw.toUpperCase()}`;
  return null;
}

/** Live typing: only complete 6-digit codes are rewritten, so "abc" can still become "abcdef". */
export function normalizeHexWhileTyping(input: string): string {
  const raw = input.trim().replace(/^#+/, '');
  return /^[0-9a-f]{6}$/i.test(raw) ? `#${raw.toUpperCase()}` : input;
}
